import { APP_CONFIG } from '@core/configs';

export const API_BASE_URL = APP_CONFIG.apiBaseUrl;
export const TOKEN_URL = APP_CONFIG.tokenUrl;

export const API_ENDPOINT = {
  token: {
    refreshToken: TOKEN_URL + 'ck-pass/token/refresh',
    logout: TOKEN_URL + 'token/logout',
  },
  auth: {
    base: TOKEN_URL + '/user',
    loginByCKPass: TOKEN_URL + 'user/login',
    verifyRefreshToken: TOKEN_URL + 'ck-pass/token/verify-refresh-token',
  },
  notifications: {
    controller: APP_CONFIG.apiBaseUrl + 'notification/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    sendTest: 'send-draft/',
    sendFinal: 'send-final/',
    getListUserByRole: 'get-list-user-by-role/',
    sendInQueue: 'send-in-queue/',
    getSendList: 'get-send-list',
  },
  notificationsDetail: {
    controller: APP_CONFIG.apiBaseUrl + 'notifications-detail/',
    getByNotificationsId: 'get-by-id/',
  },
  liveCompany: {
    controller: API_BASE_URL + 'live-company',
    getAll: '/get-all',
    getInfoSentLinked: '/get-info-sent-linked',
    deleteLiveRole: '/delete-live-role',
    updatedXmlStatus: '/updated-xml-status',
  },
  userRole: {
    controller: APP_CONFIG.apiBaseUrl + 'user-role/',
    getUserByRole: 'get-all-user-by-role/',
    getCompanyRoleByUser: 'get-company-role-by-user/',
    getSupportStaff: 'get-support-staff/',
    inviteSupportStaff: 'invite-support-staff',
    editSupportStaff: 'edit-support-staff',
    getUserIdByEmail: 'get-user-by-id',
    deleteSupportStaff: 'delete-support-staff',
    deleteAccount: 'delete-account/',
  },
  help: {
    controller: APP_CONFIG.apiBaseUrl + 'help/',
    getAll: 'get-all/',
    createDraft: 'create-draft',
  },
  loginNotice: {
    controller: APP_CONFIG.apiBaseUrl + 'login-notice/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    createFinal: 'create-final/',
    createDraft: 'create-draft/',
    update: 'update/',
  },
  template: {
    controller: APP_CONFIG.apiBaseUrl + 'template/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    deleteTemplate: 'delete-template',
  },
  mstMessage: {
    controller: APP_CONFIG.apiBaseUrl + 'mst-message/',
    getAll: 'get-all/',
    getByIds: 'get-by-ids',
  },
  noSendList: {
    controller: APP_CONFIG.apiBaseUrl + 'no-send-list/',
    excludeSend: 'exclude-send/',
  },
  saucerLog: {
    getLog: APP_CONFIG.apiBaseUrl + 'logs',
    bulkLog: APP_CONFIG.apiBaseUrl + 'logs/bulk',
  },
  version: {
    controller: APP_CONFIG.apiBaseUrl + 'version/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    create: 'create/',
    update: 'update/',
    delete: 'delete/',
    getAttachment: 'get-attachment/',
  },
  consoleRole: {
    controller: APP_CONFIG.apiBaseUrl + 'console-role/',
    getAll: 'get-all/',
    getDetails: 'get-details/',
    getPermissionsByMenu: 'get-permissions-by-menu/',
    createRole: 'create/',
    updateRole: 'update/',
    deleteRole: 'delete/',
    getRoleDetailsByUser: 'get-role-details-by-user/',
  },
  consoleUserRole: {
    controller: APP_CONFIG.apiBaseUrl + 'console-user-role/',
    getUserPermissions: 'get-user-permissions/',
    updateUserRole: 'update/',
    getAllUser: 'get-user-all',
  },
};
